import * as React from 'react';
import { Autocomplete } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { MainInput } from './Styles';
import fincartAreas from '../../constants/fincart-areas.json';

const filterAreaOptions = (options, { inputValue }) => {
  const query = inputValue.trim().toLowerCase();
  if (!query) return options;

  return options.filter((entry) =>
    (entry.en || "").toLowerCase().includes(query) ||
    (entry.ar || "").includes(inputValue.trim()) ||
    (entry.value || "").toLowerCase().includes(query)
  );
};

export const FincartAreaField = ({
  shippingService,
  city,
  area,
  onChange,
  fullWidth = true,
  margin = "normal",
  required = false,
}) => {
  const { t, i18n } = useTranslation();

  if (shippingService !== "Fincart") {
    return null;
  }

  const areas = fincartAreas[city] || [];
  const labelKey = i18n.language === "ar" ? "ar" : "en";
  const selectedOption = areas.find((entry) => entry.value === area) || null;

  return (
    <Autocomplete
      options={areas}
      value={selectedOption}
      fullWidth={fullWidth}
      disabled={!city || areas.length === 0}
      getOptionLabel={(entry) => entry[labelKey] || entry.en || entry.value}
      isOptionEqualToValue={(option, value) => option.value === value.value}
      filterOptions={filterAreaOptions}
      onChange={(_, newValue) => {
        onChange?.({ target: { value: newValue?.value || "" } });
      }}
      renderInput={(params) => (
        <MainInput
          {...params}
          margin={margin}
          required={required}
          label={t("fulfillment.area")}
        />
      )}
    />
  );
};
